/** Converts a path to crumbs.
 *  For example:
 *  "a.b[0].c" -> ["a", "b", "0", "c"]
 */
export function crumblePath(path: string | PropertyKey | PropertyKey[]): PropertyKey[] {
    return typeof path === "string" ? path.match(/[^.\[\]]+/g) || [] : [].concat(path);
}
